import {
	RadioControl, Dropdown, Button, ColorPicker 
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'

function ColorSettings( props ) {
	const {
		textColor,
		textcustomColor,
		onRemovetextColor,
		onChangecustomColor,
		onChangetextColor,

	} = props

	const customColorPickerLabel = __( 'Custom color picker', i18n )

	return (
		<div className="cartzillagb-radiobutton-bg"> 
			<Fragment>
				{ applyFilters( 'cartzillagb.color-settings.before', null, props ) }
				<RadioControl
					selected={ textColor }
					options={ applyFilters( 'cartzillagb.text-color.edit.designs', [
						{ label: __( 'Color v1', i18n ), value: 'text-primary', },
						{ label: __( 'Color v2', i18n ), value: 'text-secondary', },
						{ label: __( 'Color v3', i18n ), value: 'text-success', },
						{ label: __( 'Color v4', i18n ), value: 'text-danger', },
						{ label: __( 'Color v5', i18n ), value: 'text-warning', },
						{ label: __( 'Color v6', i18n ), value: 'text-info', },
						{ label: __( 'Color v7', i18n ), value: 'text-dark', },
						{ label: __( 'Color v8', i18n ), value: 'text-body', },
						{ label: __( 'Color v9', i18n ), value: 'text-muted', },
						{ label: __( 'Color v10', i18n ), value: 'text-black-50', },
						{ label: __( 'Color v12', i18n ), value: 'text-white', },
						{ label: __( 'Color v12', i18n ), value: 'text-light', }
					] ) }
					onChange={ onChangetextColor }
				/>
				<div className="components-color-palette__custom-clear-wrapper clear-button">
					{ onChangecustomColor &&
					<Dropdown
						className="components-color-palette__custom-color"
						contentClassName="components-color-palette__picker"
						renderToggle={ ( { isOpen, onToggle } ) => (
							<Button
								aria-expanded={ isOpen }
								onClick={ onToggle }
								aria-label={ customColorPickerLabel }
								isLink
							>
								{ __( 'Custom Color', i18n ) }
							</Button>
						) }
						renderContent={ () => (
							<ColorPicker 
								color={ textcustomColor }
								onChangeComplete={ onChangecustomColor }
								disableAlpha
							/>
						) }
					/>
					}
					<Button
						className="components-color-palette__clear"
						type="button"
						onClick={ onRemovetextColor }
						isSmall
						isDefault
					>
						{ __( 'Clear', i18n ) }
					</Button>
				</div>
				{ applyFilters( 'cartzillagb.text-color.after', null, props ) }
			</Fragment>
		</div>
	)
}

export default ColorSettings